import React from "react"
import PropTypes from "prop-types"

// components
import { SelectableItem, Icon } from "quorumdesign"
import { Tooltip } from "@quorumus/plum"

// constants
import * as constants from "app/static/frontend/design-constants"

import { useResponsiveSize } from "@/hooks"

/** ***************************************************************************
 *
 * Each enum item gets its own class; this is because each item is capable of
 * modifying the store on click.
 *
 ***************************************************************************** */

export default function EnumFilterItem(props) {
    const { isMobile } = useResponsiveSize()

    const onClick = () => {
        props.onPressItem(props.id)
    }

    return (
        <SelectableItem
            id={props.id}
            isActive={props.isActive}
            isSquare={props.multi}
            label={props.label}
            onClick={onClick}
            searchFilterTerm={props.searchFilterTerm}
        >
            {!isMobile && props.helpText && (
                <Tooltip label={props.helpText} position="top" withinPortal={false}>
                    <Icon
                        icon="info-circle"
                        iconFamily="far"
                        color={constants.QuorumGrey4}
                        style={{
                            cursor: "help",
                        }}
                    />
                </Tooltip>
            )}
        </SelectableItem>
    )
}

EnumFilterItem.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    label: PropTypes.string.isRequired,
    helpText: PropTypes.string,
    onPressItem: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    multi: PropTypes.bool.isRequired,
    // selected from the search => props.uniqueFlvId slice of the store
    searchFilterTerm: PropTypes.string,
}
